import { Box } from '@mui/material';
import { FieldProps } from '@rjsf/core';
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'ul',
  'ol',
  'li',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'a',
  'br',
  'span',
  'div',
  'code',
  'pre'
];
const ALLOWED_ATTR = ['class', 'href', 'target', 'rel', 'title'];

interface HtmlFieldOptions {
  value?: string;
}

export const HtmlField = ({ uiSchema }: FieldProps) => {
  const value = (uiSchema?.['ui:options'] as HtmlFieldOptions | undefined)?.value;

  if (!value) return null;

  const sanitized = DOMPurify.sanitize(value, { ALLOWED_TAGS, ALLOWED_ATTR });

  return <Box sx={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: sanitized }} />;
};
